import { render, staticRenderFns } from "./QuestionsThemes.vue?vue&type=template&id=82150f66"
import script from "./QuestionsThemes.vue?vue&type=script&lang=js"
export * from "./QuestionsThemes.vue?vue&type=script&lang=js"
import style0 from "./QuestionsThemes.vue?vue&type=style&index=0&id=82150f66&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports